import { useController, UseControllerProps } from "react-hook-form";
import React from "react";
import { FormControlLabel, Switch, SwitchProps, Tooltip } from "@mui/material";

export type SwitchControlProps = {
  name: string;
  label?: string | React.ReactNode;
  tooltipTitle?: string;
  rules?: UseControllerProps["rules"];
};

const SwitchControl = ({ name, label, tooltipTitle, disabled, rules }: SwitchProps & SwitchControlProps) => {
  const {
    field: { value, onChange },
  } = useController({ name, defaultValue: false, rules });

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          onChange={(_, checked) => onChange(checked)}
          disabled={disabled}
        />
      }
      label={
        <Tooltip title={tooltipTitle}>
          <span>{label}</span>
        </Tooltip>
      }
    />
  );
};

export default SwitchControl;
